import axios from 'axios';

const client = axios.create();

export default {
	getXlsxData: ({ url }) => {
		let apiUrl = url.indexOf('?') > -1 ? url : url + '?1=1';
		let currentPage = 0;
		let pageUnit = 0;
		return client
			.get(`${apiUrl}&currentPage=${currentPage}&pageUnit=${pageUnit}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
